export function isDefrentChatProductData (oldData, newData) {
    if(oldData.length!==newData.length) return true;
    const oldid = (oldData || []).map(i=> i.id);
    const newid = (newData || []).map(i=>i.id);
    const oldcategory = (oldData || []).map(i=> i.category);
    const newcategory = (newData || []).map(i=>i.category);
    const oldcategoryId = (oldcategory || []).map(i=> i.id);
    const newcategoryId = (newcategory || []).map(i=>i.id);
    const oldcategoryTitle = (oldcategory || []).map(i=> i.title);
    const newcategoryTitle = (newcategory || []).map(i=>i.title);
    const oldaddress=(oldData || []).map(i=>i.address);
    const newaddress=(newData || []).map(i=>i.address);
    const oldaddress_lat=(oldData || []).map(i=>i.address_lat);
    const newaddress_lat=(newData || []).map(i=>i.address_lat);
    const oldaddress_lon=(oldData || []).map(i=>i.address_lon);
    const newaddress_lon=(newData || []).map(i=>i.address_lon);
    const oldcall=(oldData || []).map(i=>i.call);
    const newcall=(newData || []).map(i=>i.call);
    const oldchat=(oldData || []).map(i=>i.chat);
    const newchat=(newData || []).map(i=>i.chat);
    const oldcity=(oldData || []).map(i=>i.city);
    const newcity=(newData || []).map(i=>i.city);
    const oldcount=(oldData || []).map(i=>i.count);
    const newcount=(newData || []).map(i=>i.count);
    const oldcreated_at=(oldData || []).map(i=>i.created_at);
    const newcreated_at=(newData || []).map(i=>i.created_at);
    const oldcut_count=(oldData || []).map(i=>i.cut_count);
    const newcut_count=(newData || []).map(i=>i.cut_count);
    const olddeleted_at=(oldData || []).map(i=>i.deleted_at);
    const newdeleted_at=(newData || []).map(i=>i.deleted_at);
    const olddescription=(oldData || []).map(i=>i.description);
    const newdescription=(newData || []).map(i=>i.description);
    const olddo_type=(oldData || []).map(i=>i.do_type);
    const newdo_type=(newData || []).map(i=>i.do_type);
    const oldfilter=(oldData || []).map(i=>i.filter);
    const newfilter=(newData || []).map(i=>i.filter);
    const oldlike=(oldData || []).map(i=>i.like);
    const newlike=(newData || []).map(i=>i.like);
    const oldmedia=(oldData || []).map(i=>i.media);
    const newmedia=(newData || []).map(i=>i.media);
    const oldprice=(oldData || []).map(i=>i.price);
    const newprice=(newData || []).map(i=>i.price);
    const oldself=(oldData || []).map(i=>i.self);
    const newself=(newData || []).map(i=>i.self);
    const oldstatus=(oldData || []).map(i=>i.status);
    const newstatus=(newData || []).map(i=>i.status);
    const oldtitle=(oldData || []).map(i=>i.title);
    const newtitle=(newData || []).map(i=>i.title);
    const oldupdated_at=(oldData || []).map(i=>i.updated_at);
    const newupdated_at=(newData || []).map(i=>i.updated_at);
    const olduser_account_id=(oldData || []).map(i=>i.user_account_id);
    const newuser_account_id=(newData || []).map(i=>i.user_account_id);
    const olduser_family=(oldData || []).map(i=>i.user_family);
    const newuser_family=(newData || []).map(i=>i.user_family);
    const olduser_image_type=(oldData || []).map(i=>i.user_image_type);
    const newuser_image_type=(newData || []).map(i=>i.user_image_type);
    const olduser_image_url=(oldData || []).map(i=>i.user_image_url);
    const newuser_image_url=(newData || []).map(i=>i.user_image_url);
    const olduser_name=(oldData || []).map(i=>i.user_name);
    const newuser_name=(newData || []).map(i=>i.user_name);
    const olduser_phone=(oldData || []).map(i=>i.user_phone);
    const newuser_phone=(newData || []).map(i=>i.user_phone);
    // console.log(JSON.stringify(newid)!==JSON.stringify(oldid) ||
    // JSON.stringify(newtitle)!==JSON.stringify(oldtitle) ||
    // JSON.stringify(oldcreated_at)!==JSON.stringify(newcreated_at) ||
    // JSON.stringify(oldcut_count)!==JSON.stringify(newcut_count) ||
    // JSON.stringify(oldcategory)!==JSON.stringify(newcategory) ||
    // JSON.stringify(oldcategoryId)!==JSON.stringify(newcategoryId) ||
    // JSON.stringify(oldcategoryTitle)!==JSON.stringify(newcategoryTitle) ||
    // JSON.stringify(oldaddress)!==JSON.stringify(newaddress) ||
    // JSON.stringify(oldaddress_lat)!==JSON.stringify(newaddress_lat) ||
    // JSON.stringify(oldaddress_lon)!==JSON.stringify(newaddress_lon) ||
    // JSON.stringify(oldcall)!==JSON.stringify(newcall) ||
    // JSON.stringify(oldchat)!==JSON.stringify(newchat) ||
    // JSON.stringify(oldcity)!==JSON.stringify(newcity) ||
    // JSON.stringify(oldcount)!==JSON.stringify(newcount) ||
    // JSON.stringify(olddeleted_at)!==JSON.stringify(newdeleted_at) ||
    // JSON.stringify(olddescription)!==JSON.stringify(newdescription) ||
    // JSON.stringify(olddo_type)!==JSON.stringify(newdo_type) ||
    // JSON.stringify(oldfilter)!==JSON.stringify(newfilter) ||
    // JSON.stringify(oldlike)!==JSON.stringify(newlike) ||
    // JSON.stringify(oldmedia)!==JSON.stringify(newmedia) ||
    // JSON.stringify(oldprice)!==JSON.stringify(newprice) ||
    // JSON.stringify(oldself)!==JSON.stringify(newself) ||     
    // JSON.stringify(oldstatus)!==JSON.stringify(newstatus) ||
    // JSON.stringify(oldtitle)!==JSON.stringify(newtitle) ||
    // JSON.stringify(oldupdated_at)!==JSON.stringify(newupdated_at) ||
    // JSON.stringify(olduser_account_id)!==JSON.stringify(newuser_account_id) ||
    // JSON.stringify(olduser_family)!==JSON.stringify(newuser_family) ||
    // JSON.stringify(olduser_image_type)!==JSON.stringify(newuser_image_type) ||
    // JSON.stringify(olduser_image_url)!==JSON.stringify(newuser_image_url) ||
    // JSON.stringify(olduser_name)!==JSON.stringify(newuser_name) ||
    // JSON.stringify(olduser_phone)!==JSON.stringify(newuser_phone));
    
    return JSON.stringify(newid)!==JSON.stringify(oldid) ||
    JSON.stringify(newtitle)!==JSON.stringify(oldtitle) ||
    JSON.stringify(oldcreated_at)!==JSON.stringify(newcreated_at) ||
    JSON.stringify(oldcut_count)!==JSON.stringify(newcut_count) ||
    JSON.stringify(oldcategory)!==JSON.stringify(newcategory) ||
    JSON.stringify(oldcategoryId)!==JSON.stringify(newcategoryId) ||
    JSON.stringify(oldcategoryTitle)!==JSON.stringify(newcategoryTitle) ||
    JSON.stringify(oldaddress)!==JSON.stringify(newaddress) ||
    JSON.stringify(oldaddress_lat)!==JSON.stringify(newaddress_lat) ||
    JSON.stringify(oldaddress_lon)!==JSON.stringify(newaddress_lon) ||
    JSON.stringify(oldcall)!==JSON.stringify(newcall) ||
    JSON.stringify(oldchat)!==JSON.stringify(newchat) ||
    JSON.stringify(oldcity)!==JSON.stringify(newcity) ||
    JSON.stringify(oldcount)!==JSON.stringify(newcount) ||
    JSON.stringify(olddeleted_at)!==JSON.stringify(newdeleted_at) ||
    JSON.stringify(olddescription)!==JSON.stringify(newdescription) ||
    JSON.stringify(olddo_type)!==JSON.stringify(newdo_type) ||
    JSON.stringify(oldfilter)!==JSON.stringify(newfilter) ||
    JSON.stringify(oldlike)!==JSON.stringify(newlike) ||
    JSON.stringify(oldmedia)!==JSON.stringify(newmedia) ||
    JSON.stringify(oldprice)!==JSON.stringify(newprice) ||
    JSON.stringify(oldself)!==JSON.stringify(newself) ||     
    JSON.stringify(oldstatus)!==JSON.stringify(newstatus) ||
    JSON.stringify(oldtitle)!==JSON.stringify(newtitle) ||
    JSON.stringify(oldupdated_at)!==JSON.stringify(newupdated_at) ||
    JSON.stringify(olduser_account_id)!==JSON.stringify(newuser_account_id) ||
    JSON.stringify(olduser_family)!==JSON.stringify(newuser_family) ||
    JSON.stringify(olduser_image_type)!==JSON.stringify(newuser_image_type) ||
    JSON.stringify(olduser_image_url)!==JSON.stringify(newuser_image_url) ||
    JSON.stringify(olduser_name)!==JSON.stringify(newuser_name) ||
    JSON.stringify(olduser_phone)!==JSON.stringify(newuser_phone);
}